import styled from "styled-components";

export const ValidationTableContainer = styled.div`
    .project-data {
        .epsg {
            margin-left: 10px;
        }
    }

    .ant-card-head {
        color: white;

        svg {
            fill: white;
        }
    }

    .ant-form-item-label label {
        color: white;
        font-size: 13px;
    }

    .ant-card-body {
        padding: 10px;
    }

    .ant-form-item {
        margin-bottom: 0 !important;
    }

    .ant-form-item-control-input-content {
        display: contents;
    }

    .ant-table-row-expand-icon-spaced {
        display: none;
    }

    .ant-btn {
        padding: 4px 5px;
    }

    .ant-table-row-expand-icon {
        color: black;
    }

    #validationTable {
        .ant-table {
            background: transparent;
        }
        .ant-table-wrapper .ant-table.ant-table-small {
            font-size: 12px !important;
        }

        th,
        td {
            color: white;
            background-color: #303336cc;
        }

        .extra-div {
            display: flex;

            button {
                background-color: transparent;
                border: unset;
            }

            .ant-upload-list {
                display: none;
            }
        }

        .ant-table-cell input {
            background-color: transparent;
            color: white;
        }
    }

    button.button-name-disabled {
        background-color: transparent;
        color: aliceblue;
    }

    button.button-name {
        background-color: transparent;
        color: #38f0f1;
    }

    button.button-name: hover {
        cursor: pointer;
    }

    button.button-name:focus {
        outline: none;
    }
`;
